import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, timeout, catchError, mergeMap } from 'rxjs/operators';
import { Observable} from 'rxjs';
import { AlertService } from './alert.service';
import { HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PutJsonObjectService {
  constructor(
    private http: HttpClient,
    private alertService: AlertService,
    private router: Router,
  ) { }

  public dataOutput: any;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  private resolveUrl(url: string): string {
    const apiBaseUrl = environment.url.endsWith('/') ? environment.url : `${environment.url}/`;
    if (url.startsWith('/')) {
      return `${apiBaseUrl}${url.slice(1)}`;
    }
    return `${apiBaseUrl}${url}`;
  }

  sendJson<T>(url: string, object?: any, _httpOption?: any, selfCatchError: boolean = true): Observable<any> {
    if (_httpOption != null) {
      this.httpOptions = _httpOption;
    }

    if (url != null) {
      return this.http.put(this.resolveUrl(url), object, this.httpOptions).pipe(
        map((data) => {
          return data;
        }),
        catchError((e) => {
          return new Observable((observer) => {
            if (selfCatchError) {
              if (e.error?.title != null)
                this.alertService.error({
                  subType: '',
                  message: e.error?.title + ' (' + e.error?.detail + ') type error : ' + e.error?.status,
                });
              else
                this.alertService.error({
                  subType: '',
                  message: 'Erreur de communication avec le serveur',
                });
            }
            observer.next(e);
            observer.complete();
          });
        }),
      );
    } else
      return new Observable((observer) => {
        observer.next(null);
        observer.complete();
      });
  }
}
